import { render, staticRenderFns } from "./OpenDialogIcon.vue?vue&type=template&id=e04253fa&"
import script from "./OpenDialogIcon.vue?vue&type=script&lang=js&"
export * from "./OpenDialogIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports